"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "StrategyLogo___StyledSvg",
  componentId: "sc-1e4abva-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function StrategyLogo(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.875 11.593c0 .437-.251.926-.652 1.428L7.181 6.08C8.421 5.478 9.404 4.617 10 4c.897.926 2.655 2.422 4.875 2.73v4.862zM10 16.287c-2.029-1.122-4.875-3.21-4.875-4.694V6.73c.119-.017.23-.049.346-.072l7.618 7.51c-.947.812-2.112 1.578-3.089 2.118zm5.688-11.102c-2.796 0-5.017-2.855-5.039-2.885-.307-.4-.991-.4-1.298 0-.022.03-2.244 2.885-5.039 2.885a.807.807 0 00-.812.801v5.607c0 3.05 5.495 5.99 6.121 6.315a.82.82 0 00.758 0c.626-.325 6.121-3.265 6.121-6.315V5.986c0-.442-.364-.8-.813-.8z",
    fill: "currentColor"
  }));
}

var _default = StrategyLogo;
exports["default"] = _default;